var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Toasts',{attrs:{"text":_vm.message,"color":"success"}}),_c('Toasts',{attrs:{"text":_vm.error,"color":"danger"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }